import { useCallback, useState } from 'react'

import { UserMenu as UserMenuCore } from '@writefull/ui'

import { signOut } from '@application/session/sign-out/command'

import useSessionStore from '@infrastructure/stores/session/session-store'

export default function UserMenu() {
  const user = useSessionStore((x) => x.user)
  const [isOpen, setIsOpen] = useState(false)

  const openMenu = () => setIsOpen(true)
  const closeMenu = () => setIsOpen(false)

  const signOutUser = useCallback(async () => {
    await signOut()
    closeMenu()
    const targetOrigin = import.meta.env.VITE_WF_CUSTOMER_PORTAL_URL
    window.open(`${targetOrigin}/signout?callback=x`, '_blank', '')
  }, [])

  if (!user) {
    return null
  }

  return (
    <UserMenuCore
      userName={user.email}
      isPremium={user.premium}
      isOpen={isOpen}
      onOpen={openMenu}
      onClose={closeMenu}
      onSignOut={signOutUser}
    />
  )
}
